import { DEFAULT_NOTIFICATION_SETTINGS } from "@/consts";
import type { NotificationSettingsInput } from "@/graphql/generated-types";
import { useAuthStore } from "@/stores/auth.module";

export function useDefaults() {
  const authStore = useAuthStore();

  const getActivityNotificationSettings = (): NotificationSettingsInput => {
    return {
      ...(authStore.profile?.institution.notificationSettings?.activity ||
        DEFAULT_NOTIFICATION_SETTINGS),
      institution: authStore.institutionId,
    };
  };

  return {
    getActivityNotificationSettings,
  };
}
